import { Button, Grid } from "@mui/material";
import { User } from "core/types/user.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import {
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REALM,
  KEYCLOAK_URI,
} from "../../../core/config/environment";

import "./index.css";
import { KeyValueComponent } from "components/molecules/key-value-component";

interface Props {
  user: User;
}

const account_uri =
  KEYCLOAK_URI + "/realms/" + KEYCLOAK_REALM + "/account/#/personal-info";

const ProfileCardContent: FunctionComponent<Props> = ({ user }) => {
  const { t } = useTranslation();
  return (
    <>
      <Grid container columnSpacing={4}>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.name")} value={user.firstName} />
        </Grid>
        <Grid item xs={12} sm={6} columnSpacing={4}>
          <KeyValueComponent
            label={t("profile.surname")}
            value={user.lastName}
          />
        </Grid>
      </Grid>

      <Grid container columnSpacing={4}>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.email")} value={user?.email} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.address")} value={"-"} />
        </Grid>
      </Grid>

      <Grid container columnSpacing={4}>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.company")} value={"-"} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.city")} value={"-"} />
        </Grid>
      </Grid>

      <Grid container columnSpacing={4}>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.p_iva")} value={"-"} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KeyValueComponent label={t("profile.phone")} value={"-"} />
        </Grid>
      </Grid>

      <Grid container columnSpacing={4}>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          <Button
            variant="contained"
            sx={{ marginTop: "20px" }}
            onClick={() => window.open(account_uri, "_blank", "noreferrer")}
          >
            {t("profile.edit_button")}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default ProfileCardContent;
